import httpClient from '../httpClient';

const createFillOutFormQuestion = async (data) => {
  return await httpClient.post(`fill_out_form_question/`, data);
};

const getFillOutFormQuestion = async (id) => {
  return await httpClient.get(`fill_out_form_question/${id}/`);
};

const updateFillOutFormQuestion = async (id, data) => {
  return await httpClient.patch(`fill_out_form_question/${id}/`, data);
};

const deleteFillOutFormQuestion = async (id) => {
  return await httpClient.delete(`fill_out_form_question/${id}/`);
};

const checkUsageQuestion = async (id) => {
  return await httpClient.get(`fill_out_form_question/check_usage/?question_id=${id}`);
};

export {
  createFillOutFormQuestion,
  updateFillOutFormQuestion,
  getFillOutFormQuestion,
  checkUsageQuestion,
  deleteFillOutFormQuestion,
};
